import React, { useState } from 'react';

const TooltipWeb = ({ text, children }) => {
    const [visible, setVisible] = useState(false);

    return (
        <div
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
            style={{ position: "relative", display: "inline-block" }}
        >
            {children}
            {visible && (
                <div
                    style={{
                        position: "absolute",
                        top: "120%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#333",
                        color: "#fff",
                        padding: "6px 10px",
                        borderRadius: "4px",
                        whiteSpace: "nowrap",
                        fontSize: "12px",
                        zIndex: 999,
                        opacity: visible ? 1 : 0,
                        transition: "opacity 0.2s ease-in-out",
                    }}
                >
                    {text}
                    <div
                        style={{
                            position: "absolute",
                            bottom: "100%",
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: 0,
                            height: 0,
                            borderLeft: "5px solid transparent",
                            borderRight: "5px solid transparent",
                            borderBottom: "5px solid #333",
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default TooltipWeb;
